import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import BuyInOneClick from "../../../common/BuyInOneClick";
import {buyInOneClickSelector, closeModal} from "../../ducks/buy-in-one-click";
import {authenticityTokenSelector} from "../../ducks/authenticity-token";
import {productSelector} from "../../ducks/product";
import withErrorBoundary from "../../../../decorators/withErrorBoundary";

function OneClickContainer(props) {
  const {buyInOneClick, product, authenticityToken} = props;
  return (
    <BuyInOneClick
      buyInOneClick={buyInOneClick}
      productId={product.id}
      modalIsOpen={buyInOneClick.isOpen}
      closeModal={props.closeModal}
      authenticityToken={authenticityToken}
      options={product.condition.options}
    />
  );
}

OneClickContainer.propTypes = {
  product: PropTypes.object,
  authenticityToken: PropTypes.string,
  buyInOneClick: PropTypes.object,
  closeModal: PropTypes.func
};

export default connect(
  (state) => ({
    product: productSelector(state),
    buyInOneClick: buyInOneClickSelector(state),
    authenticityToken: authenticityTokenSelector(state)
  }),
  {closeModal}
)(withErrorBoundary(OneClickContainer));
